/**
 * Where the caret goes after dictated words land — and, more importantly, what must
 * NOT happen on the way.
 *
 * Owner, 2026-09-15: 在麥克風輸入文字後 … 不要讓小鍵盤自動跳出來. 假設小鍵盤在麥克風
 * 輸入之前是收起來的, 麥克風關閉之後, 然後如果使用者沒有去點擊 text editor, 那麼小鍵盤
 * 就不該跳出來, 直接藏著, 並且在 text editor 裡面顯示文字就好了.
 *
 * The insertion used to end in an unconditional `el.focus()`. On a phone that IS the
 * soft keyboard: focus and the keyboard are the same event. So dictating with the
 * keyboard down — which is the whole point of dictating — threw half the screen away
 * the moment the words arrived, and the person had to dismiss a keyboard they never
 * asked for.
 *
 * THE RULE IS READ FROM THE LIVE DOM, not remembered from when recording started.
 * "Was it focused when they tapped the mic" is the wrong question: they may have
 * tapped into the box while it was recording, and then the keyboard is already up and
 * the caret matters. `document.activeElement` at the moment the words land answers
 * the question actually being asked — is a keyboard already on screen — without
 * having to track state across an async upload.
 *
 * WHY THE UNFOCUSED PATH TOUCHES NOTHING AT ALL, not even the selection: setting a
 * selection on an element that does not have focus is specified not to focus it, and
 * is honoured that way by current engines — but it has historically been a way to
 * focus one by accident in WebKit, which is the single engine this matters on. There
 * is nothing to gain by risking it: the next tap on the box places the caret where
 * the finger went and overwrites whatever was stored anyway.
 */
export function caretAfterDictation(el: HTMLTextAreaElement | HTMLInputElement, caret: number): boolean {
  // Not focused: the keyboard is down and must stay down. The words are already in
  // the box — that is what the person asked to see.
  if (el.ownerDocument.activeElement !== el) return false
  // Focused: the keyboard is already up and they are mid-sentence, so the caret has
  // to follow the words rather than being left wherever the value write put it.
  el.setSelectionRange(caret, caret)
  return true
}
